class Loader extends HTMLElement {
  constructor() {
    super()

    this.setSession.bind(this)
    this.getSession.bind(this)
    this.preventLoader.bind(this)
    this.loaderScroll.bind(this)

    this.timeToScroll = 2000
    this.showLoader = this.getSession()
    this.mainContent = document.querySelector('#MainContent')
    this.loader = this.querySelector('.loader')

    this.showLoader === 'false'
      ? this.preventLoader()
      : this.loaderScroll()
  }

  setSession() {
    sessionStorage.setItem("homepageLoader", 'false')
  }

  getSession() {
    const isSet = sessionStorage.getItem("homepageLoader")
    return isSet ? sessionStorage.getItem("homepageLoader") : true
  }

  preventLoader() {
    document.body.classList.remove('loading')
    this.loader.classList.add('cookie-set')
    this.mainContent.classList.remove('content-loader')
  }

  loaderScroll() {
    let timer = null
    const { loader } = this

    const scrollEvent = () => {
      const position = this.mainContent.offsetTop
      const scrolledDist = document.scrollingElement.scrollTop
      const setScrollSession = () => { this.setSession() }

      if (timer !== null) {
        clearTimeout(timer)
      }
      timer = setTimeout(function() {
        if (scrolledDist >= position) {
          setScrollSession()
          loader.classList.add('cookie-set')

          const difference = scrolledDist - position
          const elements = document.querySelectorAll('.content-loader')

          for (let index = 0; index < elements.length; index++) {
            elements[index].classList.remove('content-loader')
          }

          window.scrollTo(0,difference)
          document.removeEventListener('scroll', scrollEvent, false)
        }
      }, 150)
    }

    setTimeout(function(){
      document.body.classList.remove('loading')
    }, this.timeToScroll)

    document.addEventListener('scroll', scrollEvent, false)
  }
}

customElements.define("loader-module", Loader)